export default __webpack_public_path__ + "static/media/figure-shape.b88668b7.png";